import { SVGProps } from 'react';

const SvgQuestionsCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Z"
      clipRule="evenodd"
    />
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M12.258 8.024a2 2 0 0 0-2.225 1.308 1 1 0 1 1-1.886-.664 4 4 0 0 1 7.773 1.333c0 1.53-1.135 2.54-1.945 3.081a8.045 8.045 0 0 1-1.686.848l-.035.013-.011.003-.004.002h-.002L11.92 13l.316.949a1 1 0 0 1-.633-1.897H11.6h.002l.016-.006a5.802 5.802 0 0 0 .364-.147 6.05 6.05 0 0 0 .882-.481c.69-.46 1.055-.949 1.055-1.418v-.002a2 2 0 0 0-1.662-1.974Z"
      clipRule="evenodd"
    />
    <circle cx={12} cy={17} r={1} fill="#081930" />
  </svg>
);

export default SvgQuestionsCircle;
